import styled from 'styled-components';
import breakpoint from '../breakpoints';
const trackingToLetterSpacing = (spacing) => `${spacing/1000}em`;


export default {
  Background: styled.div`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    ${breakpoint('tablet', 'up')} {
      border-bottom: 1px solid #d9d9d9;
    }
  `,

  Wrapper: styled.div`
    text-align: center;
    max-width: 800px;
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0px 20px;
    ${breakpoint('tablet', 'up')} {
      padding: 70px 20px;
    }
    ${breakpoint('mobile')}{
      width: 90%;
      padding: 15px 0;
    }
  `,
  Heading: styled.h2`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    letter-spacing: ${trackingToLetterSpacing(50)};
    font-size: 20px;
    line-height: 1.5;

    ${breakpoint('tablet', 'up')} {
      font-size: 25px;
      line-height: 1.5;
    }
    ${breakpoint('mobile', 'up')} {
      line-height: 1.6;
    }
  `
};
